import script from "./delivery-service-evaluation.vue?vue&type=script&lang=ts&setup=true"
export * from "./delivery-service-evaluation.vue?vue&type=script&lang=ts&setup=true"

import "./delivery-service-evaluation.vue?vue&type=style&index=0&id=4d660cb5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d660cb5"]])

export default __exports__